import { LuCar } from "react-icons/lu";
import { HouseIcon } from "../../../../shared/crm/components/icons/Icon";
import "./Objects.scss";

const objects = [
  { name: "Wohnanlage Parkblick", type: "Wohnanlage" },
  { name: "Haus A", type: "Haus" },
  { name: "Haus B", type: "Haus" },
  { name: "Tiefgarage", type: "Tiefgarage" },
];

function Objects() {
  return (
    <section className="crm-objects">
      <header className="crm-objects__header">
        <h1 className="crm-objects__title">Objekte</h1>
        <p className="crm-objects__subtitle">
          Objekte sind Core-Entitäten. Module wie CRM referenzieren sie, verwalten sie aber nicht.
        </p>
      </header>

      <ul className="crm-objects__list">
        {objects.map((object) => (
          <li key={object.name} className="crm-objects__item">
            {object.type === "Tiefgarage" ? (
              <LuCar className="crm-objects__icon" aria-hidden="true" />
            ) : (
              <HouseIcon className="crm-objects__icon" aria-hidden="true" />
            )}
            <div className="crm-objects__details">
              <span className="crm-objects__name">{object.name}</span>
              <span className="crm-objects__type">{object.type}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Objects;
